import React, { useRef, useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTooth,
  faStar,
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';

const pacotes = [
  {
    id: 'pacote-mais',
    nome: 'Mais',
    subtitulo: 'Rol Ampliado',
    destaque: false,
    preco: '26,90',
    procedimentos: '219',
    coberturas: ['Cirurgias', 'Limpezas', 'Restaurações e Próteses do Rol ANS'],
  },
  {
    id: 'pacote-mais-doc',
    nome: 'Mais Doc',
    subtitulo: 'Cobertura ampliada + documentação',
    destaque: false,
    preco: '27,90',
    procedimentos: '230',
    coberturas: ['Documentação ortodôntica', 'Cirurgias', 'Extrações'],
  },
  {
    id: 'pacote-mais-clarear',
    nome: 'Mais Clarear',
    subtitulo: 'Cobertura ampliada + clareamento',
    destaque: false,
    preco: '43,90',
    procedimentos: '222',
    coberturas: [
      'Clareamento convencional',
      'Clareamento de dente desvitalizado',
      'Limpeza e Extrações',
    ],
  },
  {
    id: 'pacote-mais-orto',
    nome: 'Mais Orto',
    subtitulo: 'Cobertura ampliada + ortodontia',
    destaque: true,
    preco: '71,90',
    procedimentos: '306',
    coberturas: [
      'Documentação ortodôntica',
      'Tratamento ortodôntico completo',
      'Instalação e Manutenção de Aparelho fixo metálico',
    ],
  },
  {
    id: 'pacote-mais-pro',
    nome: 'Mais Pro',
    subtitulo: 'Cobertura ampliada + Próteses',
    destaque: false,
    preco: '79,90',
    procedimentos: '275',
    coberturas: [
      'Próteses simples e unitária',
      'Próteses cerâmicas e removíveis',
      'Dentaduras',
    ],
  },
  {
    id: 'pacote-mais-amplo',
    nome: 'Mais Amplo',
    subtitulo: 'Cobertura ampliada + Orto + Próteses + Clareamento',
    destaque: false,
    preco: '101,90',
    procedimentos: '353',
    coberturas: [
      'Tratamento ortodôntico',
      'Próteses (cerâmicas, removíveis e dentaduras)',
      'Clareamento convencional',
    ],
  },
  {
    id: 'pacote-premium',
    nome: 'Premium',
    subtitulo:
      'Cobertura ampliada + Orto + Próteses + Implante + Clareamento a laser',
    destaque: true,
    preco: '301,90',
    procedimentos: '403',
    coberturas: [
      'Próteses (cerâmicas, removíveis e dentaduras)',
      'Implante ósseo integrado',
      'Clareamento a laser',
    ],
  },
];

export default function PacotesPME() {
  const scrollContainerRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(true);

  // Atualiza a visibilidade das setas baseado na posição do scroll
  const updateArrows = () => {
    if (scrollContainerRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } =
        scrollContainerRef.current;
      setShowLeftArrow(scrollLeft > 0);
      setShowRightArrow(scrollLeft < scrollWidth - clientWidth - 10);
    }
  };

  useEffect(() => {
    const container = scrollContainerRef.current;
    if (container) {
      updateArrows();
      container.addEventListener('scroll', updateArrows);
      return () => container.removeEventListener('scroll', updateArrows);
    }
  }, []);

  // Funções de scroll com setas
  const scroll = (direction) => {
    if (scrollContainerRef.current) {
      const scrollAmount = 400;
      const newScrollLeft =
        scrollContainerRef.current.scrollLeft +
        (direction === 'left' ? -scrollAmount : scrollAmount);
      scrollContainerRef.current.scrollTo({
        left: newScrollLeft,
        behavior: 'smooth',
      });
    }
  };

  const scrollToForm = () => {
    const formElement = document.getElementById('formulario');
    if (formElement) {
      formElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  // Handlers para drag
  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - scrollContainerRef.current.offsetLeft);
    setScrollLeft(scrollContainerRef.current.scrollLeft);
  };

  const handleMouseLeave = () => {
    setIsDragging(false);
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - scrollContainerRef.current.offsetLeft;
    const walk = (x - startX) * 2;
    scrollContainerRef.current.scrollLeft = scrollLeft - walk;
  };

  // Handlers para touch (mobile)
  const handleTouchStart = (e) => {
    setIsDragging(true);
    setStartX(e.touches[0].pageX - scrollContainerRef.current.offsetLeft);
    setScrollLeft(scrollContainerRef.current.scrollLeft);
  };

  const handleTouchEnd = () => {
    setIsDragging(false);
  };

  const handleTouchMove = (e) => {
    if (!isDragging) return;
    const x = e.touches[0].pageX - scrollContainerRef.current.offsetLeft;
    const walk = (x - startX) * 2;
    scrollContainerRef.current.scrollLeft = scrollLeft - walk;
  };

  return (
    <div className="w-full bg-gradient-to-b from-gray-50 to-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Cabeçalho */}
        <div className="text-center mb-12">
          <FontAwesomeIcon
            icon={faTooth}
            className="text-blue-600 text-5xl mb-4"
          />
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Escolha o Plano Ideal para sua Empresa
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Planos odontológicos empresariais com cobertura completa e rede
            credenciada em todo o Brasil
          </p>
        </div>

        {/* Grid de Pacotes */}
        <div className="relative">
          {/* Botão Esquerda */}
          {showLeftArrow && (
            <button
              onClick={() => scroll('left')}
              className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-lg rounded-full w-12 h-12 flex items-center justify-center hover:bg-gray-100 transition-colors duration-200"
              aria-label="Rolar para esquerda"
            >
              <FontAwesomeIcon icon={faChevronLeft} className="text-blue-600" />
            </button>
          )}

          {/* Botão Direita */}
          {showRightArrow && (
            <button
              onClick={() => scroll('right')}
              className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-lg rounded-full w-12 h-12 flex items-center justify-center hover:bg-gray-100 transition-colors duration-200"
              aria-label="Rolar para direita"
            >
              <FontAwesomeIcon
                icon={faChevronRight}
                className="text-blue-600"
              />
            </button>
          )}

          {/* Container de Scroll */}
          <div
            ref={scrollContainerRef}
            onMouseDown={handleMouseDown}
            onMouseLeave={handleMouseLeave}
            onMouseUp={handleMouseUp}
            onMouseMove={handleMouseMove}
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
            onTouchMove={handleTouchMove}
            role="region"
            aria-label="Carrossel de pacotes odontológicos"
            tabIndex={0}
            className={`flex overflow-x-auto gap-6 pb-8 px-4 scrollbar-hide snap-x snap-mandatory ${isDragging ? 'cursor-grabbing' : 'cursor-grab'}`}
            style={{
              scrollbarWidth: 'none',
              msOverflowStyle: 'none',
              scrollPaddingLeft: 'calc(50% - 160px)',
              scrollPaddingRight: 'calc(50% - 160px)',
            }}
          >
            {pacotes.map((pacote) => (
              <div
                key={pacote.id}
                className={`flex-shrink-0 w-80 bg-white rounded-lg shadow-lg overflow-hidden transition-transform duration-300 hover:scale-105 select-none snap-center ${
                  pacote.destaque
                    ? 'border-4 border-blue-500 ring-2 ring-blue-200'
                    : 'border border-gray-200'
                }`}
              >
                {pacote.destaque && (
                  <div className="absolute top-0 right-0 bg-blue-500 text-white px-4 py-1 text-sm font-semibold flex items-center gap-1 z-10">
                    <FontAwesomeIcon
                      icon={faStar}
                      className="text-yellow-300"
                    />
                    <span>Popular</span>
                  </div>
                )}

                <div className="p-6 flex flex-col h-full">
                  {/* Nome do Pacote */}
                  <h3 className="text-2xl font-bold text-gray-900 mb-1">
                    {pacote.nome}
                  </h3>

                  {/* Subtítulo */}
                  <p className="text-gray-600 text-sm mb-6 min-h-[3rem]">
                    {pacote.subtitulo}
                  </p>

                  {/* Preço */}
                  <div className="mb-4">
                    <div className="flex items-baseline gap-1">
                      <span className="text-gray-700 text-lg">R$</span>
                      <span className="text-4xl font-bold text-gray-900">
                        {pacote.preco.split(',')[0]}
                      </span>
                      <span className="text-2xl font-bold text-gray-900">
                        ,{pacote.preco.split(',')[1]}*
                      </span>
                    </div>
                    <p className="text-sm text-gray-600">mensais por pessoa</p>
                  </div>

                  {/* Número de Procedimentos */}
                  <div className="bg-blue-600 text-white py-3 px-4 rounded-lg mb-4 flex items-center gap-2">
                    <FontAwesomeIcon icon={faTooth} />
                    <span className="font-semibold">
                      {pacote.procedimentos} procedimentos
                    </span>
                  </div>

                  {/* Divisor */}
                  <div className="border-t border-gray-200 mb-4"></div>

                  {/* Lista de Coberturas */}
                  <div className="space-y-3 flex-grow">
                    {pacote.coberturas.map((cobertura) => (
                      <div
                        key={`${pacote.id}-${cobertura}`}
                        className="flex items-start gap-2"
                      >
                        <FontAwesomeIcon
                          icon={faTooth}
                          className="text-blue-600 mt-1 flex-shrink-0 text-sm"
                        />
                        <span className="text-sm text-gray-700">
                          {cobertura}
                        </span>
                      </div>
                    ))}
                  </div>

                  {/* Botão de Ação */}
                  <div className="mt-6">
                    <button
                      onClick={scrollToForm}
                      className="w-full py-3 px-4 rounded-lg font-semibold transition-colors duration-200 bg-orange-600 text-white hover:bg-orange-700"
                    >
                      Contrate Agora
                    </button>
                  </div>

                  {/* IOF Footer */}
                  <div className="mt-4 text-center">
                    <p className="text-xs text-gray-500">
                      *Acréscimo de IOF(2,38%)
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
